module.exports = __webpack_public_path__ + "img/gb9115_22_a.prt.c0d55266.jpg";